module.exports = __webpack_public_path__ + "static/media/file-export.51ffd42c.svg";